import * as React from "react";
import { Button, IconButton, Menu, MenuItem, MenuList } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { ReactComponent as ArrowLeftGray } from "../../assets/pagination/arrow-left-gray.svg";
import { ReactComponent as ArrowLeftPink } from "../../assets/pagination/arrow-left-pink.svg";
import { ReactComponent as ArrowRightGray } from "../../assets//pagination/arrow-right-gray.svg";
import { ReactComponent as ArrowRightPink } from "../../assets/pagination/arrow-right-pink.svg";
import { ArrowDownFromLine } from "lucide-react";
import { Fade } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export interface Pagination {
  total: number;
  offset: number;
  hasPrevious: boolean;
  hasNext: boolean;
}

export interface PaginationDataProps {
  limit: number;
  pagination: Pagination;
  onPageNumberClick: any;
  exportOption?: ExportOption[];
}
export interface ExportOption {
  label: string;
  icon: React.ReactElement;
  onFunction?: () => void;
}

const PaginationData = ({ ...props }: PaginationDataProps) => {
  const { pagination, onPageNumberClick, exportOption } = props;
  let limit = props.limit;
  const pageButton = (pageNum: number, isSelected: boolean, next: number) => {
    let returnString = "" + pageNum;
    if (next - pageNum > 1 && next != -1) {
      returnString = returnString + "  ...";
    }
    return (
      <IconButton
        key={"page" + pageNum}
        onClick={() => onPageNumberClick(pageNum)}
      >
        <Typography color={isSelected ? "primary.dark" : "primary"}>
          {returnString}
        </Typography>
      </IconButton>
    );
  };
  if (!limit || limit <= 0) limit = 10;
  const numPages =
    pagination && pagination.total ? Math.ceil(pagination.total / limit) : 0;
  const selectedPage =
    pagination && pagination.offset ? Math.floor(pagination.offset / limit) : 0;
  let pages = [...Array(numPages).keys()];
  if (pages.length > 5) {
    pages = [
      pages[0],
      ...[selectedPage - 1, selectedPage, selectedPage + 1].filter(
        (itm) => itm >= 0 && itm <= pages[pages.length - 1]
      ),
      pages[pages.length - 1],
    ];
    pages = [...new Set(pages)];
    pages = pages.sort((a, b) => (a < b ? -1 : 1));
  }
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        mt: 2,
        mb: 2,
      }}
    >
      <Box className={"container-horizontal content-start"} sx={{ mt: 2 }}>
        <Typography color={"primary"}>
          Showing{" "}
          {limit && pagination && pagination.total
            ? Math.min(limit, pagination.total)
            : 0}{" "}
          of {pagination && pagination.total ? pagination.total : 0}
        </Typography>
      </Box>
      <Box className={"container-horizontal content-center"}>
        <IconButton
          key={"previousButton"}
          disabled={pagination && !pagination.hasPrevious}
          onClick={() => onPageNumberClick(selectedPage + 1 - 1)}
        >
          {pagination && !pagination.hasPrevious ? (
            <ArrowLeftGray />
          ) : (
            <ArrowLeftPink />
          )}
        </IconButton>
        {pages.map((k, i) =>
          pageButton(
            +k + 1,
            +k == selectedPage,
            i < pages.length - 1 ? +pages[i + 1] + 1 : -1
          )
        )}
        <IconButton
          key={"nextButton"}
          disabled={pagination && !pagination.hasNext}
          onClick={() => onPageNumberClick(selectedPage + 1 + 1)}
        >
          {pagination && !pagination.hasNext ? (
            <ArrowRightGray />
          ) : (
            <ArrowRightPink />
          )}
        </IconButton>
      </Box>
      {!exportOption && <Box />}
      {exportOption && (
        <Box className={"container-horizontal content-end"}>
          <Button
            onClick={handleClick}
            sx={{ display: "flex", gap: 2, border: "1px solid #414040" }}
          >
            <ArrowDownFromLine size={15} color="#3638C4" />
            <Typography color={"#414040"}>Export</Typography>
            {open ? (
              <KeyboardArrowUpIcon
                sx={{
                  fontSize: "15",
                }}
              />
            ) : (
              <KeyboardArrowDownIcon
                sx={{
                  fontSize: "15",
                }}
              />
            )}
          </Button>
          <Menu
            id="fade-menu"
            MenuListProps={{
              "aria-labelledby": "fade-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <MenuList
              sx={{
                width: "15rem",

                p: 0,
              }}
            >
              {exportOption?.map((option, index) => (
                <MenuItem
                  key={index}
                  onClick={option?.onFunction}
                  sx={{
                    display: "flex",
                    gap: 2,
                  }}
                >
                  {option.icon}
                  <Typography>{option.label}</Typography>
                </MenuItem>
              ))}

              {/* <MenuItem
              onClick={() => console.log()}
              sx={{
                display: "flex",
                gap: 2,
              }}
            >
              <ArrowDownFromLine size={15} color="#B027CE" />
              <Typography>All transactions</Typography>
            </MenuItem> */}
            </MenuList>
          </Menu>
        </Box>
      )}
    </Box>
  );
};

export default PaginationData;
